/* eslint-disable import/prefer-default-export */
export const T_SHIRT_SUBCAT_IDS = [
  16, 17, 18, 19, 91, 104, 112, 197, 246, 247, 354, 399, 403, 460, 505, 714, 849
];
